export const TOOL_FORM_NAME = 'toolForm';

export const TOOL_CREATE_ROUTE = '/tool/create';
export const TOOL_CREATE_URL_RELATIVE_PATTERN = '/api/tool/create';
export const TOOL_CREATE_URL_PATTERN = `{branchPath}${TOOL_CREATE_URL_RELATIVE_PATTERN}`;

export const TOOL_EDIT_ROUTE = '/tool/edit/:name';
export const TOOL_EDIT_URL_RELATIVE_PATTERN = '/api/tool/edit/{name}';
export const TOOL_EDIT_URL_PATTERN = `{branchPath}${TOOL_EDIT_URL_RELATIVE_PATTERN}`;

export const TOOL_WORKING_COPY_ORIGIN = 'WORKING_COPY_ORIGIN_TOOL_EDITOR';
